export default __webpack_public_path__ + "static/media/start-campaign.ced77c9b.svg";